// extracted by mini-css-extract-plugin
module.exports = {"block":"_3BkzPR","contain":"_2UEaPe","ratioBase":"_3VXR_a"};